"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Fieldset_1 = __importDefault(require("../fieldset/Fieldset"));
var Checkbox_1 = __importDefault(require("../checkbox/Checkbox"));
var MultiCheckbox_styled_1 = __importDefault(require("./MultiCheckbox.styled"));
function MultiCheckbox(_a) {
    var className = _a.className, legend = _a.legend, onChange = _a.onChange, options = _a.options, selectedItems = _a.selectedItems;
    return (react_1.default.createElement(MultiCheckbox_styled_1.default, { hasLegend: !!legend, className: className },
        react_1.default.createElement(Fieldset_1.default, { legend: legend }, options.map(function (option) { return (react_1.default.createElement(Checkbox_1.default, { key: option.key, name: option.value, label: option.label, checked: selectedItems.includes(option.value), onChange: function (e, name) { return onChange(e, name); } })); }))));
}
exports.default = MultiCheckbox;
//# sourceMappingURL=MultiCheckbox.js.map